import React from "react";
import MainTemplate from "../../../components/MainTemplate/MainTemplate";
import CardBackground from "../../../components/MainTemplate/CardBackground";
import SponsorsListChild from "./SponsorsListChild";

const SponsorsList = () => {
  return (
    <MainTemplate>
      <CardBackground>
        <SponsorsListChild />
      </CardBackground>
    </MainTemplate>
  );
};

export default SponsorsList;
